'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _ButtonConstants = require('./ButtonConstants');

var _Functions = require('../core/Functions');

var _UIButton = require('./UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'UIFileButton',

  propTypes: {
    accept: _react.PropTypes.array.isRequired,
    children: _react.PropTypes.node.isRequired,
    id: _react.PropTypes.string,
    multiple: _react.PropTypes.bool.isRequired,
    onChange: _react.PropTypes.func.isRequired,
    onClick: _react.PropTypes.func,
    use: _react.PropTypes.oneOf(Object.keys(_ButtonConstants.USE_CLASSES)).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      accept: [],
      multiple: false,
      use: 'tertiary-light'
    };
  },
  handleClick: function handleClick(evt) {
    var onClick = this.props.onClick;


    (0, _reactDom.findDOMNode)(this._file).click();
    (0, _Functions.callIfPossible)(onClick, evt);
  },
  fileRefCallback: function fileRefCallback(ref) {
    this._file = ref;
  },
  render: function render() {
    var _props = this.props,
        accept = _props.accept,
        children = _props.children,
        id = _props.id,
        multiple = _props.multiple,
        onChange = _props.onChange,
        __onClick = _props.onClick,
        use = _props.use,
        rest = _objectWithoutProperties(_props, ['accept', 'children', 'id', 'multiple', 'onChange', 'onClick', 'use']);

    return _react2.default.createElement(
      'span',
      { className: 'private-file-button' },
      _react2.default.createElement(
        _UIButton2.default,
        _extends({
          'data-component-name': 'UIFileButton',
          onClick: this.handleClick,
          use: use
        }, rest),
        children
      ),
      _react2.default.createElement('input', {
        className: 'hidden',
        id: id,
        ref: this.fileRefCallback,
        type: 'file',
        accept: accept.join(','),
        multiple: multiple,
        onChange: onChange
      })
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/button/UIFileButton.js
// module id = 1174
// module chunks = 2 3